import styled from 'styled-components';
import theme from '../../theme';

export const Content = styled.div`
  text-align: center;
  padding: 20px 0 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ArrowButton = styled.button`
  color: white;
  background: ${theme.colors.primary};
  border: 1px solid ${theme.colors.primary};
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  
  &:hover:not(:disabled) {
    background: ${theme.colors.title};
    border-color: ${theme.colors.title};
    transform: translateY(-2px);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const Container = styled.span`
  display: inline-block;
`;

export const Button = styled.button`
  color: #c3c3c3;
  background-color: transparent;
  border: 1px solid rgba(180, 180, 194, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 40px;
  
  &:hover {
    border-color: ${theme.colors.primary};
    color: ${theme.colors.primary};
  }

  &.selected {
    color: white;
    background: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
    font-weight: 700;
  }
`;
